var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBriefcase48Line = function SvgIconBriefcase48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 15.3h-3.2v-3.1c0-1.6-1.3-2.9-2.9-2.9h-6.6c-1.6 0-2.9 1.3-2.9 2.9v3.1h-3.2a5.31 5.31 0 0 0-5.3 5.3v12.8c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3V20.6c0-2.92-2.38-5.3-5.3-5.3Zm-13.9 3.4h9.3v16.6h-9.6V18.7h.3Zm1.7-6h5.6v2.6h-5.6v-2.6Zm-8.5 20.7V20.6c0-1.05.85-1.9 1.9-1.9h1.2v16.6h-1.2a1.9 1.9 0 0 1-1.9-1.9Zm22.6 0a1.9 1.9 0 0 1-1.9 1.9h-1.2V18.7h1.2c1.05 0 1.9.85 1.9 1.9v12.8Z",
    fill: "current"
  })));
};
export default SvgIconBriefcase48Line;